export enum GpsAuthStrategyEnum {
    CLOUDRUN = 'cloudrun',
    APIKEY = 'apikey',
    IPLIST = 'iplist',
}
